import {
  type RoleAuthorizeRequest,
  createAccessControl,
} from 'better-auth/plugins/access';
import {
  adminAc,
  defaultStatements,
  userAc,
} from 'better-auth/plugins/admin/access';

const statement = {
  ...defaultStatements,
  adminApp: ['access'],
  comp: ['manage'],
  profit: ['view'],
} as const;

export const ac = createAccessControl(statement);

/**
 * Roles answer "who is this person". Complimentary access is not a role: it
 * is a billing grant on `user_billing` (`comp_granted_at`), written by
 * `apps/api/scripts/make-comp.ts`, so an admin can be comped and a comp can be
 * revoked without touching permissions.
 */
export const roles = {
  user: ac.newRole({ ...userAc.statements }),
  staff: ac.newRole({
    ...adminAc.statements,
    user: adminAc.statements.user.filter((action) => action !== 'set-role'),
    adminApp: ['access'],
    comp: ['manage'],
  }),
  admin: ac.newRole({
    ...adminAc.statements,
    adminApp: ['access'],
    comp: ['manage'],
    profit: ['view'],
  }),
};

export type RoleName = keyof typeof roles;
export type Permissions = RoleAuthorizeRequest<typeof statement>;

const roleByName = new Map(Object.entries(roles));

export const roleCan = (
  role: string | null | undefined,
  permissions: Permissions,
) =>
  (role ?? 'user')
    .split(',')
    .some(
      (name) => roleByName.get(name)?.authorize(permissions).success === true,
    );
